/**
 * conteudoExternoBuilder — slice do conteúdo externo multi-provedor (Provedor + Unidade
 * + Conteúdo externo). Substitui a autoria nativa removida do backend.
 */
import type { $Fetch } from 'ofetch';

import {
  HttpContentProviderGateway,
  HttpExternalContentGateway,
  HttpUnidadeGateway,
} from '@/infrastructure/http/HttpConteudoExternoGateways';
import {
  ArchiveContentProvider, ArchiveExternalContent, ArchiveUnidade,
  BrowseProviderCatalog,
  CreateContentProvider, CreateExternalContent, CreateUnidade,
  ListContentProviders, ListExternalContents, ListUnidades,
  UpdateContentProvider, UpdateExternalContent, UpdateUnidade,
} from '@/application/usecase/ConteudoExternoUseCaseImpl';

export function buildConteudoExternoSlice(httpClient: $Fetch) {
  const providerGateway = new HttpContentProviderGateway(httpClient);
  const unidadeGateway = new HttpUnidadeGateway(httpClient);
  const externalGateway = new HttpExternalContentGateway(httpClient);

  const useCases = {
    listContentProviders: new ListContentProviders(providerGateway),
    createContentProvider: new CreateContentProvider(providerGateway),
    updateContentProvider: new UpdateContentProvider(providerGateway),
    archiveContentProvider: new ArchiveContentProvider(providerGateway),
    browseProviderCatalog: new BrowseProviderCatalog(providerGateway),

    listUnidades: new ListUnidades(unidadeGateway),
    createUnidade: new CreateUnidade(unidadeGateway),
    updateUnidade: new UpdateUnidade(unidadeGateway),
    archiveUnidade: new ArchiveUnidade(unidadeGateway),

    listExternalContents: new ListExternalContents(externalGateway),
    createExternalContent: new CreateExternalContent(externalGateway),
    updateExternalContent: new UpdateExternalContent(externalGateway),
    archiveExternalContent: new ArchiveExternalContent(externalGateway),
  };

  return { useCases };
}
